import { hexToRgba } from "utils/styles/hex-to-rgba";
import { Webgl2 } from "../../../webgl2";
import { Webgl2Component } from "../../webgl2-component";

export class ChessGridComponent extends Webgl2Component {
  private _gridSize = 8;
  public bgColor = "";

  public getRenderData() {
    const material = Webgl2.materials.chessGrid;
    material.setUniforms({
      u_size: this.transform.size.getAbs().getArray(),
      u_gridSize: this._gridSize,
      u_color: hexToRgba(this.bgColor, true),
    });
    return { material };
  }
}

export default ChessGridComponent;
